var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConcierge = function SvgConcierge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.7c.8 0 1.5.4 1.9 1.1L10.5 9l1.5.3c-.2.9-1 1.6-2 1.6-1.1 0-2.1-.9-2.1-2s1-2.2 2.1-2.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11 1.6 8.9 15.6c.2.3.2.8 0 1.1-.2.3-.6.6-1 .6H1.1c-.4 0-.8-.2-1-.6-.2-.3-.2-.8 0-1.1L9 1.6c.2-.4.6-.6 1-.6s.8.2 1 .6zM6.6 14.1s.1 2.7 3.3 2.7c3.2 0 3.4-2.7 3.4-2.7H6.6zM5.9 8s.1 3.4 4.3 3.4c4.3 0 3.8-3.6 3.8-3.6s-1.7-1.6-4-1.6C7.8 6.1 5.9 8 5.9 8z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgConcierge;